import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop:"50px",
    marginBottom:"100px"
  },
  container:{
    padding:"10px",
    borderRadius:"10px"
  },
  wrapper: {
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
  },
  card: {
    height: "100%",
    borderRadius: 5,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0px 15px",
    margin: 5,
  },
  title: {
    fontWeight: 700,
    fontSize: 12,
    textAlign: "center",
    color: "#333333",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "@media(min-width: 280px)": {
      fontSize: 10,
    },
    "@media(min-width: 320px)": {
      fontSize: 10,
    },
    "@media(min-width: 360px)": {
      fontSize: 12,
    },
    "@media(min-width: 960px)": {
      fontSize: 12,
    },
  },
  medium: {
    width: 60,
    height: 60,
    margin: "8px",
  },
  large: {
    width: 80,
    height: 80,
  },
  wrapImg:{
      display:"flex",
      justifyContent:"center"
  },
  wrapScroll: {
    display: "flex",
    overflowX: "auto",
    flexWrap: "nowrap",
  },
}));

export default useStyles;
